import { TimesInMinutes } from './times.enum'

export enum NotificationReminder {
  fifteenMinutes = TimesInMinutes.minute * 15,
  oneDay = TimesInMinutes.day,
}
